/* GBI gallery (B2): <gbi-gallery> and <gbi-zoom>. Spec §B2.4. Vanilla ES2019, no libraries. */
(function () {
  'use strict';
  if (window.__gbiGallery) return;
  window.__gbiGallery = true;

  var Q_DESKTOP = '(min-width: 990px)';
  var Q_REDUCED = '(prefers-reduced-motion: reduce)';
  var trackedVideo = {};

  function mq(name) {
    var G = window.GBI;
    if (G && G.mq && G.mq[name]) return G.mq[name];
    return window.matchMedia(name === 'desktop' ? Q_DESKTOP : Q_REDUCED);
  }
  function listen(list, fn) {
    if (list.addEventListener) list.addEventListener('change', fn);
    else if (list.addListener) list.addListener(fn);
  }
  function unlisten(list, fn) {
    if (list.removeEventListener) list.removeEventListener('change', fn);
    else if (list.removeListener) list.removeListener(fn);
  }
  /* Compare option values and version tags on one canonical form, so Liquid `handleize`
     and the JS side never disagree on punctuation (e.g. "Men's", "Black / Gold"). */
  function norm(str) {
    var s = String(str == null ? '' : str).toLowerCase();
    if (s.normalize) s = s.normalize('NFD').replace(/[̀-ͯ]/g, '');
    return s.replace(/[^a-z0-9]+/g, '');
  }
  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }
  function fill(tpl, vars) {
    var G = window.GBI;
    if (G && typeof G.t === 'function') return G.t(tpl, vars);
    return String(tpl).replace(/\[(\w+)\]/g, function (m, k) {
      return Object.prototype.hasOwnProperty.call(vars, k) ? String(vars[k]) : m;
    });
  }
  function track(event, params) {
    var G = window.GBI;
    if (G && typeof G.track === 'function') {
      try { G.track(event, params); } catch (e) { /* analytics never breaks the gallery */ }
    }
  }

  /* ------------------------------------------------------------------ */
  /* <gbi-gallery>                                                        */
  /* ------------------------------------------------------------------ */
  class GbiGallery extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this.track = this.querySelector('.gbi-gallery__track');
      if (!this.track) return;
      this._ready = true;

      this.slides = Array.prototype.slice.call(this.track.querySelectorAll('[data-gbi-slide]'));
      this.dotsWrap = this.querySelector('.gbi-gallery__dots');
      this.thumbsWrap = this.querySelector('.gbi-gallery__thumbs');
      this.nav = this.querySelector('.gbi-gallery__nav');
      this.countEl = this.querySelector('.gbi-gallery__count');
      this.countNow = this.querySelector('[data-gbi-count-now]');
      this.countTotal = this.querySelector('[data-gbi-count-total]');
      this.dots = this.dotsWrap ? Array.prototype.slice.call(this.dotsWrap.querySelectorAll('.gbi-gallery__dot')) : [];
      this.thumbs = this.thumbsWrap ? Array.prototype.slice.call(this.thumbsWrap.querySelectorAll('.gbi-gallery__thumb')) : [];
      this.dialog = this.querySelector('dialog.gbi-zoom');
      this.zoomEl = this.dialog ? this.dialog.querySelector('gbi-zoom') : null;
      this.root = this.closest('gbi-product');
      this.desktop = mq('desktop');
      this.reduced = mq('reduced');
      this.strImageOf = this.dataset.strImageOf || '';
      this.title = this.dataset.title || '';
      this.ratios = new Map();
      this._lockUntil = 0;

      this.videoSlide = this.track.querySelector('[data-gbi-build-video]');
      this.video = this.videoSlide ? this.videoSlide.querySelector('video') : null;
      this.playBtn = this.videoSlide ? this.videoSlide.querySelector('.gbi-gallery__play') : null;
      this.userPaused = this.reduced.matches; /* reduced motion: no autoplay */
      this.videoInView = false;
      this.videoDead = false;

      var found = this.slides.findIndex(function (s) { return s.classList.contains('is-active') && !s.hidden; });
      this.active = found >= 0 ? found : this._firstVisible();

      this._onClick = this._onClick.bind(this);
      this._onKey = this._onKey.bind(this);
      this._onVariant = this._onVariant.bind(this);
      this._onBreakpoint = this._onBreakpoint.bind(this);
      this._onReduced = this._onReduced.bind(this);
      this._onScrollEnd = this._onScrollEnd.bind(this);
      this._onVisibility = this._syncVideo.bind(this);

      this.addEventListener('click', this._onClick);
      this.addEventListener('keydown', this._onKey);
      this.track.addEventListener('scrollend', this._onScrollEnd);
      if (this.root) this.root.addEventListener('gbi:variant-change', this._onVariant);
      listen(this.desktop, this._onBreakpoint);
      listen(this.reduced, this._onReduced);
      document.addEventListener('visibilitychange', this._onVisibility);

      this._observe();
      this._initVideo();
      this._initVariant();
      this._refresh();
      this._setActive(this.active, { silent: true });
      if (!this.desktop.matches) this._scrollTo(this.active, false);
    }

    disconnectedCallback() {
      if (!this._ready) return;
      this._ready = false;
      this.removeEventListener('click', this._onClick);
      this.removeEventListener('keydown', this._onKey);
      this.track.removeEventListener('scrollend', this._onScrollEnd);
      if (this.root) this.root.removeEventListener('gbi:variant-change', this._onVariant);
      unlisten(this.desktop, this._onBreakpoint);
      unlisten(this.reduced, this._onReduced);
      document.removeEventListener('visibilitychange', this._onVisibility);
      if (this.io) this.io.disconnect();
      if (this.videoIo) this.videoIo.disconnect();
      clearTimeout(this._lockTimer);
    }

    /* ---------- helpers ---------- */
    _visible() {
      return this.slides.filter(function (s) { return !s.hidden; });
    }
    _firstVisible() {
      var i = this.slides.findIndex(function (s) { return !s.hidden; });
      return i < 0 ? 0 : i;
    }
    _indexOf(el) {
      var n = parseInt(el.getAttribute('data-index'), 10);
      return isNaN(n) ? -1 : n;
    }
    _slideAt(index) {
      return this.slides[index] || null;
    }
    _inDialog(node) {
      return !!(this.dialog && node && this.dialog.contains(node));
    }

    /* ---------- events ---------- */
    _onClick(e) {
      var t = e.target;
      if (!t || !t.closest || this._inDialog(t)) return;
      var btn = t.closest('button');
      if (!btn || !this.contains(btn)) return;

      if (btn.classList.contains('gbi-gallery__play')) {
        e.preventDefault();
        this._togglePlay();
      } else if (btn.classList.contains('gbi-gallery__zoom')) {
        if (this.dataset.zoom !== 'true') return;
        var slide = btn.closest('[data-gbi-slide]');
        if (slide) this.openZoom(this._indexOf(slide), btn);
      } else if (btn.classList.contains('gbi-gallery__arrow--prev')) {
        this.step(-1);
      } else if (btn.classList.contains('gbi-gallery__arrow--next')) {
        this.step(1);
      } else if (btn.classList.contains('gbi-gallery__dot') || btn.classList.contains('gbi-gallery__thumb')) {
        this.goTo(this._indexOf(btn), { smooth: true });
      }
    }

    _onKey(e) {
      if (e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      if (this._inDialog(e.target)) return;
      var tag = e.target && e.target.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
      if (this._visible().length < 2) return;
      e.preventDefault();
      this.step(e.key === 'ArrowLeft' ? -1 : 1, true);
    }

    _onBreakpoint() {
      this.ratios.clear();
      this._setActive(this.active, { silent: true });
      if (!this.desktop.matches) this._scrollTo(this.active, false);
    }

    _onReduced() {
      if (this.reduced.matches) this.userPaused = true;
      this._syncVideo();
    }

    _onVariant(e) {
      var d = e.detail || {};
      if (d.sectionId != null && this.dataset.sectionId && String(d.sectionId) !== String(this.dataset.sectionId)) return;
      if (!d.variant) return; /* no such combination: keep the current media */
      this._applyVariant(d.variant, true);
    }

    /* ---------- navigation ---------- */
    step(dir, focusThumb) {
      var vis = this._visible();
      if (vis.length < 2) return;
      var pos = vis.indexOf(this.slides[this.active]);
      if (pos < 0) pos = 0;
      var next = (pos + dir + vis.length) % vis.length;
      var index = this.slides.indexOf(vis[next]);
      this.goTo(index, { smooth: true });
      if (focusThumb && this.desktop.matches && this.thumbsWrap && this.thumbsWrap.contains(document.activeElement)) {
        var th = this._thumbFor(index);
        if (th) th.focus();
      }
    }

    goTo(index, opts) {
      var slide = this._slideAt(index);
      if (!slide || slide.hidden) return;
      var smooth = !!(opts && opts.smooth);
      if (!this.desktop.matches) this._scrollTo(index, smooth);
      this._setActive(index);
    }

    _scrollTo(index, smooth) {
      var slide = this._slideAt(index);
      if (!slide || slide.hidden) return;
      var cs = window.getComputedStyle(this.track);
      var padStart = parseFloat(cs.scrollPaddingLeft) || 0;
      var left = Math.max(0, slide.offsetLeft - padStart);
      var behavior = smooth && !this.reduced.matches ? 'smooth' : 'auto';
      /* Ignore observer noise from the slides we pass on the way. */
      this._lockUntil = Date.now() + (behavior === 'smooth' ? 700 : 80);
      clearTimeout(this._lockTimer);
      this._lockTimer = setTimeout(this._onScrollEnd, behavior === 'smooth' ? 720 : 100);
      if (typeof this.track.scrollTo === 'function') this.track.scrollTo({ left: left, behavior: behavior });
      else this.track.scrollLeft = left;
    }

    _onScrollEnd() {
      this._lockUntil = 0;
      this._pickFromRatios();
    }

    _observe() {
      var self = this;
      if (!('IntersectionObserver' in window)) return;
      this.io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { self.ratios.set(en.target, en.intersectionRatio); });
        if (Date.now() < self._lockUntil) return;
        self._pickFromRatios();
      }, { root: this.track, threshold: [0, 0.6, 1] });
      this.slides.forEach(function (s) { self.io.observe(s); });
    }

    _pickFromRatios() {
      if (this.desktop.matches) return;
      var best = -1;
      var bestR = 0;
      for (var i = 0; i < this.slides.length; i++) {
        var s = this.slides[i];
        if (s.hidden) continue;
        var r = this.ratios.get(s) || 0;
        if (r >= 0.6 && r >= bestR) { best = i; bestR = r; }
      }
      if (best >= 0 && best !== this.active) this._setActive(best);
    }

    _setActive(index, opts) {
      var slide = this._slideAt(index);
      if (!slide) return;
      var prev = this.active;
      this.active = index;
      this.slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      var mark = function (el) {
        var on = parseInt(el.getAttribute('data-index'), 10) === index;
        el.classList.toggle('is-active', on);
        if (on) el.setAttribute('aria-current', 'true');
        else el.removeAttribute('aria-current');
      };
      this.dots.forEach(mark);
      this.thumbs.forEach(mark);
      var vis = this._visible();
      if (this.countNow) this.countNow.textContent = pad(Math.max(1, vis.indexOf(slide) + 1));
      if (this.desktop.matches) this._revealThumb(index);
      this._pauseNative(index);
      this._syncVideo();
      if (!(opts && opts.silent) && prev !== index) {
        this.dispatchEvent(new CustomEvent('gbi:gallery-change', {
          bubbles: true,
          detail: {
            index: index,
            mediaId: slide.getAttribute('data-media-id') || null,
            type: slide.getAttribute('data-gbi-slide-type') === 'video' ? 'video' : 'image'
          }
        }));
      }
    }

    _thumbFor(index) {
      for (var i = 0; i < this.thumbs.length; i++) {
        if (parseInt(this.thumbs[i].getAttribute('data-index'), 10) === index) return this.thumbs[i];
      }
      return null;
    }

    _revealThumb(index) {
      var wrap = this.thumbsWrap;
      var th = this._thumbFor(index);
      if (!wrap || !th || wrap.scrollWidth <= wrap.clientWidth) return;
      var item = th.parentElement;
      var left = item.offsetLeft - wrap.offsetLeft;
      if (left < wrap.scrollLeft) wrap.scrollLeft = left;
      else if (left + item.offsetWidth > wrap.scrollLeft + wrap.clientWidth) wrap.scrollLeft = left + item.offsetWidth - wrap.clientWidth;
    }

    /* Product videos / external videos (not the build video): pause when left. */
    _pauseNative(index) {
      var self = this;
      this.slides.forEach(function (s, i) {
        if (i === index || s === self.videoSlide) return;
        var v = s.querySelector('video');
        if (v && !v.paused) v.pause();
      });
    }

    /* ---------- labels, dots, thumbs, counter (step 4) ---------- */
    _refresh() {
      var self = this;
      var vis = this._visible();
      var n = vis.length;
      var posOf = function (index) {
        var s = self.slides[index];
        return s ? vis.indexOf(s) + 1 : 0;
      };
      vis.forEach(function (s, i) {
        s.setAttribute('aria-label', (i + 1) + ' / ' + n);
        if (s.hasAttribute('data-gbi-alt-auto')) {
          var img = s.querySelector('img');
          if (img) img.alt = self.strImageOf ? self.title + ' — ' + fill(self.strImageOf, { x: i + 1, n: n }) : self.title;
        }
      });
      this.dots.forEach(function (d) {
        var index = self._indexOf(d);
        var s = self.slides[index];
        d.hidden = !s || s.hidden;
        if (!d.hidden) {
          var x = posOf(index);
          d.setAttribute('aria-label', self.strImageOf ? fill(self.strImageOf, { x: x, n: n }) : x + ' / ' + n);
        }
      });
      this.thumbs.forEach(function (t) {
        var index = self._indexOf(t);
        var s = self.slides[index];
        var li = t.parentElement;
        var hide = !s || s.hidden;
        if (li) li.hidden = hide;
        if (!hide) t.setAttribute('aria-label', posOf(index) + ' / ' + n);
      });
      var multi = n > 1;
      this.classList.toggle('gbi-gallery--single', !multi);
      if (this.dotsWrap) this.dotsWrap.hidden = !multi;
      if (this.thumbsWrap) this.thumbsWrap.hidden = !multi;
      if (this.nav) this.nav.hidden = !multi;
      if (this.countEl) this.countEl.hidden = !multi;
      if (this.countTotal) this.countTotal.textContent = pad(Math.max(1, n));
      if (this.countNow) this.countNow.textContent = pad(Math.max(1, posOf(this.active)));
      if (this.zoomEl && typeof this.zoomEl.sync === 'function') this.zoomEl.sync(this.slides);
    }

    /* ---------- version media (steps 1-4) ---------- */
    _initVariant() {
      /* Init order rule: read the live state; Liquid already filtered for data-variant-id. */
      if (!this.root) return;
      var vid = this.root.dataset.variantId;
      if (!vid || vid === this.dataset.variantId) return;
      var dataEl = this.root.querySelector('[data-gbi-product-data]');
      if (!dataEl) return;
      var data;
      try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var v = (data.variants || []).find(function (x) { return String(x.id) === String(vid); });
      if (v) this._applyVariant(v, false);
    }

    _applyVariant(variant, navigate) {
      var selected = (variant.options || []).map(norm);
      var tagged = this.slides.filter(function (s) {
        return (s.getAttribute('data-gbi-variant-tags') || '').trim() !== '';
      });
      if (tagged.length) {
        var isRemoved = function (s) { return s.hasAttribute('data-gbi-removed'); };
        this.slides.forEach(function (s) {
          if (isRemoved(s)) { s.hidden = true; return; }
          var tags = (s.getAttribute('data-gbi-variant-tags') || '').trim();
          if (!tags) { s.hidden = false; return; }
          s.hidden = !tags.split(/\s+/).some(function (t) { return selected.indexOf(norm(t)) !== -1; });
        });
        var anyImage = this.slides.some(function (s) {
          return !s.hidden && s.getAttribute('data-gbi-slide-type') !== 'video';
        });
        if (!anyImage) tagged.forEach(function (s) { if (!isRemoved(s)) s.hidden = false; });
      }

      /* Step 3: featured media if visible; else stay (G.1) unless hidden; else first visible. */
      var target = -1;
      if (variant.featured_media_id != null) {
        var fid = String(variant.featured_media_id);
        target = this.slides.findIndex(function (s) { return !s.hidden && s.getAttribute('data-media-id') === fid; });
      }
      if (target < 0) {
        var cur = this.slides[this.active];
        target = cur && !cur.hidden ? this.active : this._firstVisible();
      }
      this._refresh();
      if (navigate) {
        this.goTo(target, { smooth: true });
      } else {
        this._setActive(target, { silent: true });
        if (!this.desktop.matches) this._scrollTo(target, false);
      }
    }

    /* ---------- build video (slot 2) ---------- */
    _initVideo() {
      var self = this;
      if (!this.video) return;
      this.video.muted = true;
      this.video.addEventListener('playing', function () {
        var pid = (self.root && self.root.dataset.productId) || self.dataset.productId || '';
        if (trackedVideo[pid]) return;
        trackedVideo[pid] = true;
        track('gallery_video_play', { product_id: Number(pid) || pid });
      });
      this.video.addEventListener('pause', function () { self._syncPlayBtn(); });
      this.video.addEventListener('play', function () { self._syncPlayBtn(); });
      /* <source> errors don't bubble: capture them on the video. */
      this.video.addEventListener('error', function () {
        var v = self.video;
        if (v.error || v.networkState === 3) self._videoFailed();
      }, true);
      if ('IntersectionObserver' in window) {
        this.videoIo = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { self.videoInView = en.isIntersecting && en.intersectionRatio >= 0.5; });
          self._syncVideo();
        }, { threshold: [0, 0.5, 1] });
        this.videoIo.observe(this.videoSlide);
      } else {
        this.videoInView = true;
      }
      this._syncPlayBtn();
    }

    _videoFailed() {
      if (this.videoDead) return;
      this.videoDead = true;
      if (this.playBtn) this.playBtn.hidden = true;
      if (this.video.getAttribute('poster')) return; /* poster stays as a still */
      this.videoSlide.setAttribute('data-gbi-removed', '');
      this.videoSlide.hidden = true;
      var wasActive = this.slides[this.active] === this.videoSlide;
      this._refresh();
      if (wasActive) this.goTo(this._firstVisible(), { smooth: false });
    }

    _syncVideo() {
      var v = this.video;
      if (!v || this.videoDead) return;
      var want = this.slides[this.active] === this.videoSlide && this.videoInView && !this.userPaused && !document.hidden && !this.videoSlide.hidden;
      if (want && v.paused) {
        var self = this;
        var p = v.play();
        if (p && typeof p.catch === 'function') {
          p.catch(function () {
            /* autoplay blocked (e.g. low-power mode): show the play state */
            self.userPaused = true;
            self._syncPlayBtn();
          });
        }
      } else if (!want && !v.paused) {
        v.pause();
      }
      this._syncPlayBtn();
    }

    _togglePlay() {
      var v = this.video;
      if (!v || this.videoDead) return;
      if (this.userPaused || v.paused) {
        this.userPaused = false;
        var self = this;
        var p = v.play();
        if (p && typeof p.catch === 'function') p.catch(function () { self.userPaused = true; self._syncPlayBtn(); });
      } else {
        this.userPaused = true;
        v.pause();
      }
      this._syncPlayBtn();
    }

    _syncPlayBtn() {
      var b = this.playBtn;
      if (!b) return;
      var showPlay = this.userPaused;
      b.classList.toggle('is-paused', showPlay);
      /* V3M-6: no control in the peek; it shows once the video slide is half in view */
      b.classList.toggle('is-off', !this.videoInView);
      var label = showPlay ? b.getAttribute('data-label-play') : b.getAttribute('data-label-pause');
      if (label) b.setAttribute('aria-label', label);
    }

    /* ---------- zoom ---------- */
    openZoom(index, opener) {
      if (!this.dialog || !this.zoomEl || this.dataset.zoom !== 'true') return;
      if (typeof this.zoomEl.show === 'function') this.zoomEl.show(index, opener);
    }
  }

  /* ------------------------------------------------------------------ */
  /* <gbi-zoom> (inside a native <dialog class="gbi-zoom">)              */
  /* ------------------------------------------------------------------ */
  class GbiZoom extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this.dialog = this.closest('dialog');
      this.track = this.querySelector('.gbi-zoom__track');
      if (!this.dialog || !this.track) return;
      this._ready = true;
      this.items = Array.prototype.slice.call(this.track.querySelectorAll('.gbi-zoom__item'));
      this.closeBtn = this.querySelector('.gbi-zoom__close');
      this.prevBtn = this.querySelector('.gbi-zoom__arrow--prev');
      this.nextBtn = this.querySelector('.gbi-zoom__arrow--next');
      this.nowEl = this.querySelector('[data-gbi-zoom-now]');
      this.totalEl = this.querySelector('[data-gbi-zoom-total]');
      this.countEl = this.querySelector('.gbi-zoom__count');
      this.reduced = mq('reduced');
      this.current = this.items[0] || null;
      this.ratios = new Map();
      this._pending = null;

      this._onClick = this._onClick.bind(this);
      this._onKey = this._onKey.bind(this);
      this._onClose = this._onClose.bind(this);
      this.addEventListener('click', this._onClick);
      this.addEventListener('keydown', this._onKey);
      this.dialog.addEventListener('close', this._onClose);

      var self = this;
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { self.ratios.set(en.target, en.intersectionRatio); });
          var best = null;
          var bestR = 0;
          self._visible().forEach(function (li) {
            var r = self.ratios.get(li) || 0;
            if (r >= 0.6 && r >= bestR) { best = li; bestR = r; }
          });
          if (best && best !== self.current) { self.current = best; self._count(); }
        }, { root: this.track, threshold: [0, 0.6, 1] });
        this.items.forEach(function (li) { self.io.observe(li); });
      }
      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(function () { self._flush(); });
        this.ro.observe(this.track);
      }
      this._count();
    }

    disconnectedCallback() {
      if (!this._ready) return;
      this._ready = false;
      this.removeEventListener('click', this._onClick);
      this.removeEventListener('keydown', this._onKey);
      if (this.dialog) this.dialog.removeEventListener('close', this._onClose);
      if (this.io) this.io.disconnect();
      if (this.ro) this.ro.disconnect();
    }

    _visible() {
      return this.items.filter(function (li) { return !li.hidden; });
    }

    /* Called by <gbi-gallery> after version filtering. */
    sync(slides) {
      this.items.forEach(function (li) {
        var s = slides[parseInt(li.getAttribute('data-index'), 10)];
        li.hidden = !s || s.hidden;
      });
      if (this.current && this.current.hidden) this.current = this._visible()[0] || null;
      this._count();
    }

    _count() {
      var vis = this._visible();
      var n = vis.length;
      var pos = this.current ? vis.indexOf(this.current) + 1 : 1;
      if (this.nowEl) this.nowEl.textContent = pad(Math.max(1, pos));
      if (this.totalEl) this.totalEl.textContent = pad(Math.max(1, n));
      var multi = n > 1;
      if (this.countEl) this.countEl.hidden = !multi;
      if (this.prevBtn) this.prevBtn.hidden = !multi;
      if (this.nextBtn) this.nextBtn.hidden = !multi;
    }

    show(index, opener) {
      var vis = this._visible();
      var target = vis.find(function (li) { return parseInt(li.getAttribute('data-index'), 10) === index; }) || vis[0];
      if (!target) return;
      this.opener = opener || null;
      this._pending = target;
      this.current = target;
      this._count();
      var G = window.GBI;
      var self = this;
      var p;
      if (G && G.dialog && typeof G.dialog.open === 'function') {
        p = G.dialog.open(this.dialog, { opener: opener, history: true });
      } else {
        if (!this.dialog.open) this.dialog.showModal();
        p = Promise.resolve();
      }
      this._flush();
      Promise.resolve(p).then(function () {
        self._flush();
        if (self.dialog.open && !self.dialog.contains(document.activeElement) && self.closeBtn) self.closeBtn.focus();
      }, function () {});
    }

    /* Jump to the pending item once the dialog has layout (no animated scroll on open). */
    _flush() {
      var li = this._pending;
      if (!li || !this.dialog.open || this.track.clientWidth === 0) return;
      this._pending = null;
      this.track.scrollLeft = li.offsetLeft;
    }

    hide(reason) {
      var G = window.GBI;
      if (G && G.dialog && typeof G.dialog.close === 'function') {
        G.dialog.close(this.dialog, { reason: reason || 'close' });
      } else if (this.dialog.open) {
        this.dialog.close();
      }
    }

    _onClose() {
      this._pending = null;
      /* Without GBI.dialog, restore focus ourselves. */
      var G = window.GBI;
      if (!(G && G.dialog) && this.opener && document.contains(this.opener)) this.opener.focus();
    }

    step(dir) {
      var vis = this._visible();
      if (vis.length < 2) return;
      var pos = Math.max(0, vis.indexOf(this.current));
      var next = vis[(pos + dir + vis.length) % vis.length];
      this.current = next;
      this._count();
      var behavior = this.reduced.matches ? 'auto' : 'smooth';
      if (typeof this.track.scrollTo === 'function') this.track.scrollTo({ left: next.offsetLeft, behavior: behavior });
      else this.track.scrollLeft = next.offsetLeft;
    }

    _onClick(e) {
      var btn = e.target && e.target.closest ? e.target.closest('button') : null;
      if (!btn) return;
      if (btn === this.closeBtn) this.hide('close');
      else if (btn === this.prevBtn) this.step(-1);
      else if (btn === this.nextBtn) this.step(1);
    }

    _onKey(e) {
      if (e.altKey || e.ctrlKey || e.metaKey) return;
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        e.preventDefault();
        e.stopPropagation();
        this.step(e.key === 'ArrowLeft' ? -1 : 1);
      }
    }
  }

  if (!customElements.get('gbi-zoom')) customElements.define('gbi-zoom', GbiZoom);
  if (!customElements.get('gbi-gallery')) customElements.define('gbi-gallery', GbiGallery);
})();
